import React from "react";
import { connect } from "react-redux";
import Dropdown from "./Dropdown";
import { localeChange } from "../../store/locale";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserCart } from "../../store/cart";

function DropdownLanguage({ locale, localeChange: changeLocale, location, history }) {
    const languages = [
        { title: "EN-English", locale: "en", code: "EN" },
        { title: "FR-Francais", locale: "fr", code: "FR"},
    ];

    const dispatch = useDispatch();

    const language = languages.find((x) => x.locale === locale) || languages[0];

    const userId = useSelector((state) => state.user.userConnected.user?.id);

    const handleLanguageChange = (newLocale) => {
        const urlParams = new URLSearchParams(location.search);
        urlParams.set("lang", newLocale);
        // Met à jour l'URL sans changer de page
        dispatch(fetchUserCart(userId, newLocale)); // Fetch the user's cart after login
        history.push(`${location.pathname}?${urlParams.toString()}`);
        localStorage.setItem("preferredLanguage", newLocale);
        changeLocale(newLocale);
    };

    const title = (
        <>
            <div>{language.code}</div>
        </>
    );

    return (
        <div className="topbar-dropdown">
            <Dropdown
                title={title}
                withIcons
                items={languages}
                onClick={(item) => handleLanguageChange(item.locale)}
                aria-label="Language Selector"
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

const mapDispatchToProps = {
    localeChange,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DropdownLanguage));
